import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { PageObjectContainer } from "./pageobjectcontainer";
import { PageObjectText } from "./pageobjecttext";
import { PageObjectLink } from "./pageobjectlink";
import { PageObjectImage } from "./pageobjectimage";
import { PageObjectSound } from "./pageobjectsound";
import { PageObjectButton } from "./pageobjectbutton";
import { PageObjectSelection } from "./pageobjectselection";
import { PageObjectInput } from "./pageobjectinput";
import { PageObjectEvaluation } from "./pageobjectevaluation";
import { PageObjectVideo } from "./pageobjectvideo";
import { PageObjectArrow } from "./pageobjectarrow";
import { PageObjectUploadButton } from "./pageobjectuploadbutton";
import { PageObjectList } from "./pageobjectlist";
import { Page } from "./page";

export class Utils {
  static duplicateObject(obj: PageObject, page: Page = null, style: string = ""): PageObject {
    let ret: PageObject = null;
    if (obj.constructor.name == "Object") {
      (<any>obj).type = (<any>obj)._type; // obj is JSON not the object, so I fake the type property. The "any" type is to avoid typing error
    }

    if (obj.type == PAGEOBJECTTYPE.Container) {
      ret = new PageObjectContainer(<PageObjectContainer>obj, page);
    } else if (obj.type == PAGEOBJECTTYPE.Text) {
      ret = new PageObjectText(<PageObjectText>obj, style);
    } else if (obj.type == PAGEOBJECTTYPE.Link) {
      ret = new PageObjectLink(<PageObjectLink>obj, style);
    } else if (obj.type == PAGEOBJECTTYPE.Image) {
      ret = new PageObjectImage(<PageObjectImage>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Sound) {
      ret = new PageObjectSound(<PageObjectSound>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Button) {
      ret = new PageObjectButton(<PageObjectButton>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Selection) {
      ret = new PageObjectSelection(<PageObjectSelection>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Input) {
      ret = new PageObjectInput(<PageObjectInput>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Evaluation) {
      ret = new PageObjectEvaluation(<PageObjectEvaluation>obj);
    } else if (obj.type == PAGEOBJECTTYPE.Video) {
      ret = new PageObjectVideo(<PageObjectVideo>obj);
    } else if (obj.type == PAGEOBJECTTYPE.UploadButton) {
      ret = new PageObjectUploadButton(<PageObjectUploadButton>obj);
    } else if (obj.type == PAGEOBJECTTYPE.List) {
      ret = new PageObjectList(<PageObjectList>obj, style);
    } else if (obj.type == PAGEOBJECTTYPE.Arrow) {
      ret = new PageObjectArrow(<PageObjectArrow>obj, style);
    }

    return ret;
  }
}
